import { BellOutlined } from '@ant-design/icons'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Badge, Button, Popover, notification } from 'antd'
import { StyledTimeline } from '$globalStyledComponents/Navbar'
import * as dayjs from 'dayjs'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  fetchUnreadNotifications,
  markNotificationAsRead,
  markAllNotificationsAsRead,
} from '../api/evoAPIs'
import { useColorByHeaderBackground } from '$utils/useColorByHeaderBackground'
import { useTheme } from 'styled-components'

var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([])
  const [bellCount, setBellCount] = useState(0)
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const theme = useTheme()
  const iconColor = useColorByHeaderBackground(theme)

  useQuery({
    queryKey: ['notifications'],
    queryFn: fetchUnreadNotifications,
    onSuccess: (data) => {
      setBellCount(data.length)
      setNotifications(data)
    },
    onError: (err) => {
      console.error(err.response?.status)
      if (err?.response?.status === 403) {
        window.location.reload()
      } else {
        openErrorNotification(
          err.response?.status
            ? toString(err.response?.status)
            : toString(err?.message),
        )
      }
    },
  })
  const openErrorNotification = (err) => {
    notification.error({
      message: 'Network Error',
      description:
        err + `: There is a server error, cannot fetch notifications`,
      onClick: () => {},
    })
  }
  const content = (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <b>{t('notifications')}</b>
        {notifications.length > 0 && (
          <Button
            onClick={async () => {
              await markAllNotificationsAsRead()
              queryClient.invalidateQueries(['notifications'])
            }}
          >
            {t('mark_all_as_read')}
          </Button>
        )}
      </div>
      <StyledTimeline
        mode="left"
        items={notifications.map((noti) => ({
          label: dayjs(noti.created_at).fromNow(),
          children: (
            <>
              <div dangerouslySetInnerHTML={{ __html: noti.detail_text }} />
              <Button
                onClick={async () => {
                  await markNotificationAsRead(noti.id)
                  queryClient.invalidateQueries(['notifications'])
                }}
              >
                {t('mark_as_read')}
              </Button>
            </>
          ),
        }))}
      />
      <div style={{ textAlign: 'center' }}>{/* <a>View More...</a> */}</div>
    </>
  )

  return (
    <div className="info-circle" style={{ margin: '7px 20px 0 0' }}>
      {/* <StyledDropdownMenue overlayStyle={{ width: '200px' }} menu={{ items: notificationItems }} placement="bottom" trigger={['click']}> */}
      <Popover
        overlayStyle={{ width: '350px' }}
        trigger="click"
        arrow={false}
        content={bellCount > 0 ? content : t('no_unread_notifications')}
      >
        <div
          className="info-circle"
          style={{ cursor: 'pointer', padding: '7px' }}
        >
          <Badge count={bellCount} offset={[3, 0]}>
            <BellOutlined
              style={{ fontSize: '18px', paddingBottom: 20, color: iconColor }}
            />
          </Badge>
        </div>
      </Popover>
      {/* </StyledDropdownMenue> */}
    </div>
  )
}

export default NotificationBell
